import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=40f619ff"
import script from "./activate.component.ts?vue&type=script&lang=ts&external"
export * from "./activate.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f619ff')) {
      api.createRecord('40f619ff', component.options)
    } else {
      api.reload('40f619ff', component.options)
    }
    module.hot.accept("./activate.vue?vue&type=template&id=40f619ff", function () {
      api.rerender('40f619ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/account/activate/activate.vue"
export default component.exports